import { Button, Card, Col, Form, Input, Row, Select, Table } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { DownloadOutlined, UndoOutlined,StarOutlined,SearchOutlined,ArrowUpOutlined,ArrowDownOutlined } from '@ant-design/icons';
import { RMGrnService } from '@gtpl/shared-services/raw-material-procurement';
import Highlighter from 'react-highlight-words';
import { Excel } from 'antd-table-saveas-excel';

const RmBudgetVarianceReport = () => {
  const { Option } = Select;
  const [data, setData] = useState([]);
  const service=new RMGrnService()
  const [form] = Form.useForm();
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);


//   useEffect(() => {
//     getRmBudgetVarianceReport(); 
//   }, []); 

  const getRmBudgetVarianceReport  = (month = undefined, year = undefined) => {
    service.getGrnItemsForRmBudgetReport(month, year).then((res) => {
      console.log(res,"ressssssssssssssssssssssssss")
      if (res.status) {
        setData(res.data);
      }else {
        setData([]); 
      }
    });
  };

  const monthMapping = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 20 }, (_, i) => currentYear - i);

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      )
        : null

  });

  /**
   * 
   * @param selectedKeys 
   * @param confirm 
   * @param dataIndex 
   */
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };

  const excelcolumns:any[] = [
    {
      title: 'S No',
      render: (text, object, index) => (index == data.length ? null : index + 1),
    },
    {
      title: 'Procurement Person',
      dataIndex: 'employeeName',
      render: (text, record) => (record.employeeName ? record.employeeName : '-'),
    },
    {
      title: 'Year',
      dataIndex: 'grnBudgetYear',
      render: (text, record) => text ?? record.year,
    },
    {
      title: 'Month', 
      dataIndex: 'grnBudgetMonth',
      render: (text, record) => monthMapping[Number(text)] ?? record.month,
    },
   
    {
      title: 'Count',
      dataIndex: 'count',
      render: (text, record) => {
        let value = record.count ?? record.budgetCount ?? 0;
        const formatValue = (val) => {
          const numericValue = parseFloat(val);
          return !isNaN(numericValue) ? (Number.isInteger(numericValue) ? numericValue : numericValue.toFixed(2)) : val;
        };
        if (typeof value === 'string' && value.includes('-')) {
          const rangeParts = value.split('-');
          if (rangeParts.length === 2) {
            return `${formatValue(rangeParts[0])}-${formatValue(rangeParts[1])}`;
          }
        }
        return formatValue(value);
      },
    },
    {
      title: 'Budget',
      dataIndex: 'budgetQuantity',
      render: (text) => (text != null ? text : 0),
    },
    {
      title: 'Actual Containers',
      dataIndex: 'grnQuantity',
      render: (text, record) => {
        const budget = record.grnQuantity != null ? record.grnQuantity : 0;
        return (
          <span>
            {budget}
            </span>
        );
      },
    },
    {
      title: 'Variance',
      render: (text, record) => {
        const budget = record.budgetQuantity != null ? record.budgetQuantity : 0;
        const grnQuantity = record.grnQuantity != null ? record.grnQuantity : 0;
        const variance = Math.abs(budget - grnQuantity);
        return (
          <span>
            {variance}
          </span>
        );
      },
    },
  ];
  
  // const exportExcel = () => {
  //   const excel = new Excel();
  //   excel
  //     .addSheet('Budget Variance Report')
  //     .addColumns(excelcolumns)
  //     .addDataSource(data.map(record => ({
  //       ...record,
  //       grnQuantity: record.grnQuantity != null ? record.grnQuantity : 0,
  //       budgetQuantity: record.budgetQuantity != null ? record.budgetQuantity : 0,
  //       variance: (record.budgetQuantity || 0) - (record.grnQuantity || 0),
  //     })))
  //     .saveAs('Budget Variance Report.xlsx');
  // };
  const exportExcel = () => {
    const excel = new Excel();
  
    // Calculate totals
      let totalBudgetContainers = 0;
  let totalContainers = 0;
  let totalNetAmount = 0;

  data.forEach(({ budgetQuantity, grnQuantity }) => {
    totalBudgetContainers += parseFloat(budgetQuantity) || 0;
    totalContainers += parseFloat(grnQuantity) || 0;
  });

  totalNetAmount = totalBudgetContainers - totalContainers;

  // Append total row
  const totalRow = {
    employeeName: "Total", // Identifier for total row
    budgetQuantity: totalBudgetContainers.toFixed(2),
    grnQuantity: totalContainers.toFixed(2),
    variance: totalNetAmount.toFixed(2),
  };
  
    // Append total row to data
    const exportData = [...data, totalRow];
  
    excel
      .addSheet("quantity-deviation-report")
      .addColumns(excelcolumns)
      .addDataSource(exportData, { str2num: true })
      .saveAs("Budget Variance Report.xlsx");
  };
  
  const Columns: any[] = [
    {
      title: 'S No',
        render: (text, object, index) => (index == data.length ? null : index + 1),
    },
    {
      title: 'Procurement Person',
      dataIndex: 'employeeName',

      ...getColumnSearchProps('employeeName'),
      render:(e,val)=>{
        return (val.employeeName? val.employeeName:'-')
      },
    },
    {
      title: 'Year',
      dataIndex: 'grnBudgetYear',
      render: (text, r) => text ?? r.year,
      // ...getColumnSearchProps('grnBudgetYear'),
    },
    {
      title: 'Month',
      dataIndex: 'grnBudgetMonth',
      render: (text, r) => monthMapping[Number(text)] ?? r.month,
      // ...getColumnSearchProps('grnBudgetMonth'),
    },

    {
      title: 'Count',
      dataIndex: 'count',
      render: (text, r) => {
        let value = r.count;
    
        if (value === null || value === undefined) {
          value = r.budgetCount;
        }
    
        // Function to format the value
        const formatValue = (val) => {
          const numericValue = parseFloat(val);
          if (!isNaN(numericValue)) {
            return Number.isInteger(numericValue) ? numericValue : numericValue.toFixed(2);
          }
          return val;
        };
    
        // Check if the value is a range
        if (typeof value === 'string' && value.includes('-')) {
          const rangeParts = value.split('-');
          if (rangeParts.length === 2) {
            const formattedStart = formatValue(rangeParts[0]);
            const formattedEnd = formatValue(rangeParts[1]);
            return `${formattedStart}-${formattedEnd}`;
          }
        } else {
          return formatValue(value);
        }
      },
    },
    
    
    
    
    {
      title: 'Budget',
      dataIndex: 'budgetQuantity',
      render: (text) => (text != null ? text : 0),
      sorter: (a, b) => a.budgetQuantity - b.budgetQuantity,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Quantity',
      dataIndex: 'grnQuantity',
      render: (text, record) => {
        const budget = record.budgetQuantity != null ? record.budgetQuantity : 0;
        return (
          <>
            {text !== null ? text : 0}
            {budget === 0 && text > 0 && ( 
              <StarOutlined style={{ color: 'Orange' }} />
            )}
          </>
        );
      },
      sorter: (a, b) => {
        const aActualContainers = a.grnQuantity !== null ? a.grnQuantity : 0;
        const bActualContainers = b.grnQuantity !== null ? b.grnQuantity : 0;
        return aActualContainers - bActualContainers;
      },
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Variance',
      render: (text, record) => {
        const budget = record.budgetQuantity != null ? record.budgetQuantity : 0;
        const grnQuantity = record.grnQuantity != null ? record.grnQuantity : 0;
        const variance = Math.abs(budget - grnQuantity); 
        let icon;
        if (grnQuantity >= budget) {
          icon = <ArrowUpOutlined style={{ color: 'green', marginRight: 4 }} />;
        } else {
          icon = <ArrowDownOutlined style={{ color: 'red', marginRight: 4 }} />;
        }
        return (
          <span>
            {variance}
            {icon}
          </span>
        );
      },
    },
  ];

  const resetHandler = () => {
    form.resetFields();
    setData([]);
    getRmBudgetVarianceReport()
  };

  const onFinish = (values) => {
    console.log(values,"valuesssssssssssssssssssss")
    const month = values.month ? parseInt(values.month, 10) : undefined;
    console.log(month,"monthhhhhhhhhhh frontendddddddddddddd")
    const year = values.year ? parseInt(values.year, 10) : undefined;
    console.log(year,"yearrrrrrrrrrrrrr frontendddddddddddddd")

    getRmBudgetVarianceReport(month, year);
  };

  useEffect(() => {
    getRmBudgetVarianceReport(); 
  }, []); 

  return (
    <div>
      <Card
        size="small"
        title={<span style={{ color: 'white' }}>Budget Variance Report</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={<Button onClick={() => { exportExcel(); }}>Get Excel</Button>}
      >
        <Form form={form} onFinish={onFinish} layout='vertical'>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={8} lg={8} xl={6}>
              <Form.Item name="month" label="Month">
                <Select
                  placeholder="Select Month"
                  allowClear
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {Object.entries(monthMapping).map(([key, value]) => (
                    <Option key={key} value={parseInt(key)}>
                      {value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={6}>
              <Form.Item name="year" label="Year">
                <Select placeholder="Select Year" allowClear showSearch>
                  {years.map((year) => (
                    <Option key={year} value={year}>
                      {year}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>
          <Form.Item>
            <Button type='primary' htmlType='submit'>Get Report</Button>
          </Form.Item>
        </Col>
        <Col style={{ paddingLeft: '10px', marginTop: '30px' }}>
          <Form.Item>
            <Button
              onClick={resetHandler}
              type="primary"
              
              
              icon={<UndoOutlined />}
            >
              Reset
            </Button>
          </Form.Item>
        </Col>
          </Row>
        </Form>
        <Table columns={Columns} dataSource={data}  pagination={{
          pageSize:100,
          onChange(current) {
            setPage(current);
          }
        }}
        summary={(pageData) => {
          let totalBudgetContainers = 0;
          let totalContainers = 0;
          let totalNetAmount = 0;
        
          pageData.forEach(({ budgetQuantity,grnQuantity }) => {
              totalBudgetContainers += parseFloat(budgetQuantity) || 0;
              totalContainers += parseFloat(grnQuantity) || 0;
              totalNetAmount = totalContainers-totalBudgetContainers
            });
        
          return (
            <Table.Summary.Row>
              <Table.Summary.Cell index={4} colSpan={5}>
                Total
              </Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                {totalBudgetContainers.toFixed(2)}
              </Table.Summary.Cell>

              <Table.Summary.Cell index={6}>
                {totalContainers.toFixed(2)}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={7}>
                {totalNetAmount.toFixed(2)}
              </Table.Summary.Cell>
            </Table.Summary.Row>
          );
        }}
        />
      </Card>
    </div>
  );
};

export default RmBudgetVarianceReport;
